import { HUMANLY_MAIN_APP_URL } from "@/common/Env";

const base_url = HUMANLY_MAIN_APP_URL;

const get_request = async (endpoint, params = {}) => {
  const url = new URL(`${base_url}/${endpoint}`);
  Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, v));

  const response = await fetch(url, {
    credentials: "include",
    headers: { "Accept": "application/json" },
  });

  if (!response.ok) {
    throw new Error(`Humanly API error: ${response.status} ${response.statusText}`);
  }

  return response.json();
};

const put_request = async (endpoint, body = {}) => {
  const url = new URL(`${base_url}/${endpoint}`);

  const response = await fetch(url, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`Humanly API error: ${response.status} ${response.statusText}`);
  }

  return response.json();
};


const contactsRequest = (endpoint, team_profile_id) => (
  get_request(`api/profiles/contacts/${endpoint}`, { crm_team_profile_id: team_profile_id })
);

const updateContactsRequest = (uuid, attrs) => (
  put_request(`api/profiles/contacts?uuid=${uuid}`, attrs)
);


export const fetchResume = ({ team_profile_id }) =>
  contactsRequest("resume", team_profile_id);

export const fetchDetails = ({ team_profile_id }) =>
  contactsRequest("details", team_profile_id);


export const fetchConversations = ({ team_profile_id }) =>
  contactsRequest("conversations", team_profile_id);

export const fetchInterviews = ({ team_profile_id }) =>
  contactsRequest("interviews", team_profile_id);

export const fetchTranscript = ({ id }) =>
  get_request(`api/conversations/${id}/transcript`);

export const fetchEvents = () =>
  get_request("api/events");

export const fetchContactEvents = ({ team_profile_id }) =>
  contactsRequest("events", team_profile_id);

export const fetchMeetings = ({ team_profile_id }) =>
  contactsRequest("meetings", team_profile_id);


export const fetchCandidacies = ({ team_profile_id }) =>
  contactsRequest("candidacies", team_profile_id);


export const HumanlyApi = {
  fetchResume,
  fetchConversations,
  fetchInterviews,
  fetchTranscript,
  fetchDetails,
  fetchEvents,
  fetchContactEvents,
  fetchMeetings,
  updateContactsRequest,
  fetchCandidacies,
};
